module.exports = __webpack_public_path__ + "img/kg.a9d0e38.svg";